import React from 'react';
import { useDispatch } from 'react-redux';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import moment from 'moment';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent } from '@mui/material';
import { bypassReminder } from '../modules/actiondata';
import { useTranslation } from 'react-i18next';

export default function ActionRow(props) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [confirmSkip, setConfirmSkip] = React.useState(false);

    const disableButtons =
        props.disableButtons != null && props.disableButtons !== undefined ? props.disableButtons : false;

    const onAddToBasket = () => {
        props.newOrderFromLocations([props.action.location.id]);
    };

    const openLocation = () => {
        props.history.push('/locations/' + props.action.location.id);
    };

    const skip = () => {
        setConfirmSkip(true);
    };

    const cancelSkip = () => {
        setConfirmSkip(false);
    };

    const doSkip = () => {
        const due = moment(props.action.due);
        setConfirmSkip(false);
        // month() + 1 --> moment().month() values 0...11.
        dispatch(bypassReminder(due.month() + 1, due.year(), props.action.location.id))
            .then(() => {})
            .catch((err) => {});
    };

    const ConfirmationDialog = () => {
        const theme = useTheme();
        const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
        if (confirmSkip)
            return (
                <Dialog
                    onClose={cancelSkip}
                    aria-labelledby="simple-dialog-title"
                    open={confirmSkip}
                    fullWidth={true}
                    maxWidth={'md'}
                    fullScreen={fullScreen}>
                    <DialogContent dividers>{t('frontpage.confirmBypassReminder')}</DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            color="primary"
                            name="btn-modal-poista"
                            id="modal-poista"
                            onClick={doSkip}>
                            {t('buttons.bypass')}
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                            variant="contained"
                            sx={{ bgcolor: 'grey.300', color: 'text.primary', '&:hover': { bgcolor: 'grey.400' } }}
                            name="btn-modal-peruuta"
                            id="modal-peruuta"
                            onClick={cancelSkip}>
                            {t('buttons.cancel')}
                        </Button>
                    </DialogActions>
                </Dialog>
            );
        return null;
    };

    let action = props.action;

    return (
        <Grid container spacing={1} justifyContent={'space-between'} className="action-item-row" alignItems="center">
            <Grid item>
                {action.customer != null && props.showCustomer && (
                    <span style={{ fontSize: '1.3em', fontWeight: '500', verticalAlign: 'middle' }}>
                        {action.customer.name}
                        <br />
                    </span>
                )}
                {action.location != null && (
                    <React.Fragment>
                        <OpenInNewIcon name={'openlocation'} sx={{ verticalAlign: 'middle', cursor: 'pointer' }} onClick={openLocation} />
                        <span style={{ fontSize: '1.3em', fontWeight: '500', verticalAlign: 'middle' }}>{action.location.name}</span>
                    </React.Fragment>
                )}
            </Grid>
            {action.completed != null && <Grid item>{moment(action.completed).format('DD.MM.YYYY HH:mm')}</Grid>}
            {action.completed == null && (
                <Grid item>
                    {disableButtons && (
                        <Grid item>
                            <Button variant="contained" name="btn-skip" color="primary" disabled>
                                <SkipNextIcon />
                                &nbsp;{t('buttons.bypass')}
                            </Button>
                            <Button variant="contained" name="btn-order" color="primary" disabled>
                                <AddShoppingCartIcon />
                                &nbsp;{t('buttons.addToCart')}
                            </Button>
                        </Grid>
                    )}

                    {!disableButtons && (
                        <Grid item container spacing={1}>
                            <Grid item>
                                <Button variant="contained" name="btn-skip" color="primary" onClick={skip}>
                                    <SkipNextIcon />
                                    &nbsp;{t('buttons.bypass')}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" name="btn-order" color="primary" onClick={onAddToBasket}>
                                    <AddShoppingCartIcon />
                                    &nbsp;{t('buttons.addToCart')}
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            )}
            <ConfirmationDialog />
        </Grid>
    );
}
